<a routerLink="/shows/{{show.slug}}/podcasts">
  <div class="image" [responsiveBackgroundImage]="show.logo_square || show.logo1" [widthFactor]="0.1">
  </div>

  <div class="name">
    <div>
      {{show.name}}
    </div>
  </div>
</a>